import React from "react";
import { Book, Store, Package, TrendingUp } from "lucide-react";

const NAV_ITEMS = [
  { id: "resumen", icon: TrendingUp, label: "Resumen" },
  { id: "catalogo", icon: Book, label: "Catálogo" },
  { id: "librerias", icon: Store, label: "Librerías" },
  { id: "operaciones", icon: Package, label: "Operaciones" }
];

export default function Sidebar({ activeTab, onTabChange }) {
  return (
    <nav className="bg-indigo-900 text-white w-full md:w-64 flex-shrink-0">
      <div className="p-6">
        <h1 className="text-2xl font-bold tracking-wider">
          EDITORIAL<br />
          <span className="text-indigo-400">HUB</span>
        </h1>
      </div>
      <div className="flex md:flex-col overflow-x-auto md:overflow-visible">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={`flex items-center space-x-3 w-full p-4 text-left whitespace-nowrap transition-colors ${
              activeTab === item.id ? "bg-indigo-800 border-l-4 border-indigo-400" : "hover:bg-indigo-800/50"
            }`}
          >
            <item.icon size={20} className={activeTab === item.id ? "text-indigo-400" : "text-gray-400"} />
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
